import { forwardRef } from 'react';
import { BannerProps } from './banner.interface';
import { BannerContainer } from './banner.styles';

export const Banner = forwardRef<HTMLDivElement, BannerProps>((props, ref) => {
  const { children, imgSrc } = props;

  return (
    <BannerContainer ref={ref} {...props}>
      <div className="banner-copy">{children}</div>
      {imgSrc ? <img src={imgSrc} alt="Imagen del baner" /> : null}
    </BannerContainer>
  );
});

Banner.displayName = 'Banner';
